const LOCAL_STORAGE_SUBSCRIBE_NEWSLETTER = 'subscribeNewsletter';
const LOCAL_STORAGE_ADD_WISHLIST_PRODUCT = 'addWishlistProduct';
const LOCAL_STORAGE_IS_SAME_AS_SHIPPING = 'isSameAsShipping';
const LOCAL_STORAGE_SAVE_IN_ADDRESS_BOOK = 'saveInAddressBook';

export { LOCAL_STORAGE_SUBSCRIBE_NEWSLETTER as L, LOCAL_STORAGE_ADD_WISHLIST_PRODUCT as a, LOCAL_STORAGE_IS_SAME_AS_SHIPPING as b, LOCAL_STORAGE_SAVE_IN_ADDRESS_BOOK as c };
//# sourceMappingURL=localStorage-h6SlcHvK.js.map
